export default {
    namespaced: true,
    state() {
        return {
            objectiveToDuplicate: null,
        };
    },
    mutations: {
        setObjectiveToDuplicate(state, objective) {
            state.objectiveToDuplicate = objective;
        }
    },
    actions: {
        setObjectiveToDuplicateAction({ commit }, objective) {
            commit('setObjectiveToDuplicate', objective);
        },
        clearObjectiveToDuplicateAction({ commit }) {
            commit('setObjectiveToDuplicate', null);
        }
    },
};
